var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuroIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17 11.1961C4.81667 11.1961 3.78067 10.7621 3.062 9.89406C2.34333 9.01673 1.984 7.71473 1.984 5.98806V5.79206C1.984 4.06539 2.32933 2.76806 3.02 1.90006C3.71067 1.02273 4.728 0.584061 6.072 0.584061C6.87467 0.584061 7.53733 0.714727 8.06 0.976061C8.58267 1.23739 8.97467 1.59673 9.236 2.05406C9.50667 2.51139 9.656 3.03873 9.684 3.63606H8.48C8.44267 3.04806 8.22333 2.58606 7.822 2.25006C7.42067 1.90473 6.83733 1.73206 6.072 1.73206C5.13867 1.73206 4.42467 2.05406 3.93 2.69806C3.43533 3.34206 3.188 4.40606 3.188 5.89006C3.188 7.37406 3.44467 8.43806 3.958 9.08206C4.48067 9.72606 5.218 10.0481 6.17 10.0481C6.96333 10.0481 7.55133 9.88006 7.934 9.54406C8.31667 9.19873 8.52667 8.73206 8.564 8.14406H9.768C9.74 8.75073 9.59533 9.28273 9.334 9.74006C9.07267 10.1974 8.68067 10.5567 8.158 10.8181C7.63533 11.0701 6.97267 11.1961 6.17 11.1961ZM0.752 7.54206V6.61806H6.968V7.54206H0.752ZM1.004 5.41406V4.49006H7.22V5.41406H1.004Z",
    fill: "#9499A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euroIcon.d679731d77569931c30d3b16f3abde61.svg";
export { ForwardRef as ReactComponent };